/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

import Flickity from 'flickity';

/*------------------------------------*\
    CAROUSEL MODULE
\*------------------------------------*/
class Carousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        var elem = $(this);

        var cellCount = elem.children('.js-carousel__cell').length;
        var draggable = (cellCount > 1 ? true : false);

        var carousel = new Flickity(self.elem, {
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            draggable: draggable
        });

        var caption = $('.js-carousel__caption');
        var flkty = elem.data('flickity');
        var navButtonsGroup = $('.js-carousel__nav__page-buttons');
        var navButtons = navButtonsGroup.find('.js-carousel__nav-button--page');
        var videoCells = elem.find('.js-carousel__cell[data-video-embed-url]');

        // Update selected navButtons
        carousel.on('select.flickity', function () {
            navButtons.filter('.is-active').removeClass('is-active');
            navButtons.eq(flkty.selectedIndex).addClass('is-active');

            $.each(videoCells, function (index, elem) {
                elem.querySelector('[data-video-embed]').setAttribute('src', '');
            });

            if (flkty.selectedElement.hasAttribute('data-video-embed-url')) {
                var iframe = flkty.selectedElement.querySelector('[data-video-embed]');
                var embedUrl = flkty.selectedElement.getAttribute('data-video-embed-url');

                iframe.setAttribute('src', embedUrl);
            }
        });

        // Select cell on button click
        navButtonsGroup.on('click', '.js-carousel__nav-button--page', function () {
            var index = $(this).index();
            carousel.select(index);

            navButtons.filter('.is-active').removeClass('is-active');
            navButtons.eq(index).addClass('is-active');
        });

        // Previous
        $('.js-carousel__nav-button--prev').on('click', function () {
            carousel.previous();
            
            navButtons.filter('.is-active').removeClass('is-active');
            navButtons.eq(carousel.selectedIndex).addClass('is-active');
        });

        // Next
        $('.js-carousel__nav-button--next').on('click', function () {
            carousel.next();
            
            navButtons.filter('.is-active').removeClass('is-active');
            navButtons.eq(carousel.selectedIndex).addClass('is-active');
        });

        // Update caption on change
        carousel.on('select', function () {
            var selectedCaption = carousel.selectedElement.getAttribute('data-title');

            if (selectedCaption.length > 0) {
                caption.text(selectedCaption);
            }
            else {
                caption.html('\u00A0');
            }
        });
    }
}

export default Carousel;